Ext.define('SA.view.menu.AddOtherYears', {
    alias: 'widget.add-other-years-menu-item',
    extend: 'Ext.menu.Item',

    text: 'Add Other Years',

    initComponent() {
        this.menu = {
            cls: 'sa-add-other-years-menu',

            items: [{
                xtype: 'simple-container',
                cls: 'sa-add-other-years-menu-loading-item',
                items: [{xtype: 'spinner', width: 18}]
            }]
        };

        this.callParent();
    },

    initEvents() {
        this.callParent();

        this.menu.on('boxready', () => this.onChildMenuBoxReady());
        this.menu.on('hide', () => this.onChildMenuHide());
    },

    getChildMenuCheckItemCfg(attribute) {
        return {
            xtype: 'menucheckitem',
            checked: this.model.containsAttribute(attribute.attribute),
            attribute: attribute.attribute,

            listeners: {
                render: item => {
                    var html = attribute.year + SA.AttributeBadges.forYear(attribute);

                    item.textEl.setHTML(html);
                }
            }
        };
    },

    getChildMenuItemCfgs({attributes}) {
        if (attributes.length === 0) {
            return {
                xtype: 'menuitem',
                disabled: true,
                text: '(No other years available)',
                cls: 'sa-add-other-years-menu-no-other-years-item'
            };
        }

        return attributes
            .sort(SA.data.Sort.numericByKey('year'))
            .map(attribute => this.getChildMenuCheckItemCfg(attribute));
    },

    async getOtherAttributes() {
        var {country, censusRelease} = SA.data.AttributesCache.get(this.attribute),
            attributeSeries = await SA.AttributesQueryBuilder.valueOf('attributeSeries')
                .forAttribute(this.attribute)
                .run();

            return SA.AttributesQueryBuilder.select('attribute')
                .where('attributeSeries', attributeSeries)
                .statusVisible()
                .censusRelease({country, censusRelease})
                .limit(1000)
                .run()
                .then(ids => ids.filter(id => id !== this.attribute))
                .then(ids => SA.data.AttributesCache.getPromise(ids));
    },

    async onChildMenuBoxReady() {
        var attributes = await this.getOtherAttributes();

        if (!this.isDestroyed) {
            Ext.suspendLayouts();

            this.menu.removeAll();
            this.menu.add(this.getChildMenuItemCfgs({attributes}));

            Ext.resumeLayouts(true);
        }
    },

    onChildMenuHide() {
        var items = this.menu.query('menucheckitem'),
            uncheckedItems = items.filter(item => !item.checked),
            checkedAttributes = items.filter(item => item.checked).map(item => item.attribute);

        uncheckedItems.forEach(item => this.model.removeAttribute(item.attribute));

        this.model.addAttributesAfter({after: this.attribute, attributes: checkedAttributes});
        this.model.save();
    },

    onDestroy() {
        this.callParent();

        SA.data.AttributesCache.queuePurge();
    }
});